<div class="toolbar">
  <div class="search-box">
    <em class="fal fa-search"></em>
    <input
      #filter
      type="text"
      placeholder="Filtrer par personnel"
      (keyup)="personFilter(filter.value)"
      (keyup.enter)="personFilter(filter.value)"
    />
  </div>
  <span class="grid-count">{{ filtered.length }} personne(s)</span>
  @if (selectedTag) {
  <span class="filter-chip">
    Tag : {{ selectedTag.name }}
    <button type="button" (click)="removeFilter()" aria-label="Retirer le filtre">
      <em class="fal fa-times"></em>
    </button>
  </span>
  }
</div>

@if (users) {
<div class="table-responsive">
  <table class="table table-striped table-hover grid-table">
    <thead>
      <tr>
        <th class="sortable grid-user-col" (click)="sort(null)">Voir tout</th>
        @for (tag of tags; track tag) {
        <th class="sortable" (click)="sort(tag)">
          {{ tag.name }}
          @if (sortColumn == tag) {
          <em class="fal" [ngClass]="sortDirection == 'ASC' ? 'fa-caret-up' : 'fa-caret-down'"></em>
          }
        </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (user of filtered; track user) {
      <tr>
        <td class="grid-user-col">{{ user.lastname }} {{ user.firstname }}</td>
        @for (t of user.tags; track t) {
        <td>
          <button
            type="button"
            class="tag-toggle"
            [class.tag-toggle-on]="t.enable"
            (click)="toggle(user, t)"
          >
            @if (t.enable) {
            <em class="fal fa-check"></em>
            }
            {{ t.name }}
          </button>
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>
}
